import DynamicFormPage from './container';

export default DynamicFormPage;
